import React, { useState } from 'react';
import { 
  AppBar, 
  Toolbar, 
  Button, 
  IconButton, 
  Menu, 
  MenuItem, 
  Box, 
  Typography, 
  Drawer,
  Divider,
  List,
  ListItem,
  ListItemText,
  Collapse,
  useMediaQuery,
  useTheme
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom'; // AJOUT DE CETTE IMPORTATION

const logoPath = `${process.env.PUBLIC_URL}/assets/logo.png`;

// Couleurs de votre logo
const colors = {
  primary: '#0d933a', // Vert
  secondary: '#e30b14', // Rouge
  background: '#fefffe' // Blanc
};

// Menus secondaires (en haut)
const secondaryMenuItems = [
  { label: 'À propos', to: '/apercuINSBU' },
  { label: 'Historique', to: '/historiqueINSBU' },
  { label: 'Résultats RGPHAE 2024', to: '/resultatRGPHAE2024' },
  { label: 'Visa Statistiques', to: '/visa' },
   { label: 'Contact', to: '/contactUs' },
  
];

// Menus principaux
const primaryMenuItems = [
  { 
    icon: <HomeIcon sx={{ color: colors.primary, fontSize: '1.3rem' }} />, 
    to: '/',
    label: 'ACCUEIL'
  },
  { 
    label: 'PUBLICATIONS', 
    hasSubmenu: true,
    subItems: [
      { label: 'COMPTES NATIONAUX', to: '/comptesNationaux' },
      { label: "COMPTES DE L'ENERGIE", to: '/comptesEnergie' },
      { label: 'INDICES', to: '/indice' },
      { label: 'BULLETINS', to: '/bulletin' },
      { label: "NEWSSTAT", to: '/NewsState' },
      { label: 'ANNUAIRES', to: '/annuaire' },
      { label: 'REFERENTIEL DES PRIX DU BURUNDI', to: '/mercuriale' },
      { label: 'BILANS ALIMENTAIRES', to: '/rapportsBilansAlimentaires' },
      { label: "RAPPORTS D' ENQUÊTES ET DE RECENSEMENT", to: '/rapport' },
      { label: 'TABLEAU DE BORD SOCIAL', to: '/tableauBordSocial' },
      { label: 'INDICATEURS DHD', to: '/indicateurDHD' },
      { label: 'INDICATEURS ODD', to: '/indicateurs/odd' },
      { label: 'INDICATEURS PND', to: '/indicateurs/pnd' },
      { label: 'PROFIL SOCIO-ÉCONOMIQUE', to: '/socioEconomicProfile' },
      { label: 'CAHIERS INSBU', to: '/cahiersINSBU' },
    ]
  },
  { 
    label: 'SECTORIELS', 
    to: '/sectoral'
  },
  { 
    label: 'DONNÉES', 
    to: '/data'
  },
  { 
    label: 'INFOGRAPHIES', 
    to: '/infographie'
  },
  { 
    label: 'ACTUALITÉS', 
    hasSubmenu: true,
    subItems: [
      { label: 'ACTUALITÉS ET ÉVÉNEMENTS', to: '/actualitesEtEvenements' },
      { label: 'ENQUÊTES', to: '/ongoingSurveysPage' },
      { label: 'RECRUTEMENTS', to: '/recruitmentPage' },   
      { label: 'CALENDRIER', to: '/calendarTable' },
    ]
  },
 
    { 
    label: 'CADRE JURIDIQUE', 
    to: '/documentINSBU'
  },
];

const NavigationBar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentMenu, setCurrentMenu] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileSubmenuOpen, setMobileSubmenuOpen] = useState({});
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const navigate = useNavigate(); // MAINTENANT DÉFINI

  const handleMenuOpen = (event, menuType) => {
    setAnchorEl(event.currentTarget);
    setCurrentMenu(menuType);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setCurrentMenu(null);
  };

  const handleDrawerToggle = () => {
    setMenuOpen(!menuOpen);
  };

  const handleMobileSubmenuToggle = (menuLabel) => {
    setMobileSubmenuOpen(prev => ({
      ...prev,
      [menuLabel]: !prev[menuLabel]
    }));
  };

  const handleNavigation = (path) => {
    handleMenuClose();
    setMenuOpen(false);
    navigate(path);
  };

  const getSubmenuItems = (menuLabel) => {
    const menu = primaryMenuItems.find(item => item.label === menuLabel);
    return menu?.subItems || [];
  };

  // Render mobile menu items
  const renderMobileMenuItems = () => {
    return primaryMenuItems.map((item) => (
      <Box key={item.label || 'home'}>
        {item.hasSubmenu ? (
          <>
            <ListItem 
              button 
              onClick={() => handleMobileSubmenuToggle(item.label)}
              sx={{
                '&:hover': { 
                  backgroundColor: 'rgba(13, 147, 58, 0.1)',
                }
              }}
            >
              <ListItemText 
                primary={
                  <Typography sx={{ fontWeight: 'bold', color: colors.primary }}>
                    {item.label}
                  </Typography>
                } 
              />
              {mobileSubmenuOpen[item.label] ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={mobileSubmenuOpen[item.label]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {getSubmenuItems(item.label).map((subItem) => (
                  <ListItem 
                    key={subItem.label}
                    button 
                    onClick={() => handleNavigation(subItem.to)}
                    sx={{ 
                      pl: 4,
                      '&:hover': { 
                        backgroundColor: 'rgba(227, 11, 20, 0.1)',
                      }
                    }}
                  >
                    <ListItemText 
                      primary={
                        <Typography variant="body2" sx={{ color: '#555' }}>
                          {subItem.label}
                        </Typography>
                      } 
                    />
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </>
        ) : (
          <ListItem 
            button 
            onClick={() => handleNavigation(item.to)}
            sx={{
              '&:hover': { 
                backgroundColor: 'rgba(13, 147, 58, 0.1)',
              }
            }}
          >
            <ListItemText 
              primary={
                <Typography sx={{ 
                  fontWeight: item.label === 'ACCUEIL' ? 'normal' : 'bold',
                  color: colors.primary
                }}>
                  {item.label}
                </Typography>
              } 
            />
          </ListItem>
        )}
        <Divider />
      </Box>
    ));
  };

  return (
    <>
      <AppBar 
        position="static"
        sx={{ 
          backgroundColor: colors.background, 
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)', 
          borderBottom: `3px solid ${colors.primary}`,
        }}
      >
        <Toolbar sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          minHeight: { xs: '70px', md: '80px' },
          padding: { xs: '0 16px', md: '0 24px' }
        }}>
          {/* Logo et nom */}
          <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <IconButton
              edge="start"
              aria-label="menu"
              onClick={handleDrawerToggle}
              sx={{ display: { xs: 'flex', lg: 'none' }, mr: 1 }}
            >
              <MenuIcon sx={{ color: colors.primary, fontSize: '1.8rem' }} />
            </IconButton>

            <Button 
              onClick={() => handleNavigation('/')} 
              sx={{ 
                display: 'flex', 
                alignItems: 'center',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'transparent' }
              }}
            >
              <img 
                src={logoPath} 
                alt="Logo INSBU" 
                style={{ 
                  height: isMobile ? '50px' : '60px', 
                  marginRight: '12px' 
                }} 
              />
              <Typography 
                variant="h6" 
                sx={{ 
                  display: { xs: 'none', sm: 'block' },
                  color: colors.primary,
                  fontWeight: 'bold',
                  fontSize: { xs: '14px', md: '16px' },
                  textAlign: 'left'
                }}
              >
                Institut National de la Statistique du Burundi
              </Typography>
            </Button>
          </Box>

          {/* Desktop Navigation */}
          <Box sx={{ 
            display: { xs: 'none', lg: 'flex' }, 
            flexDirection: 'column', 
            alignItems: 'flex-end',
            flex: 2
          }}>
            {/* Menus secondaires (en haut) */}
            <Box sx={{ 
              display: 'flex', 
              marginBottom: '8px',
              justifyContent: 'flex-end'
            }}>
              {secondaryMenuItems.map((item) => (
                <Button
                  key={item.label}
                  onClick={() => handleNavigation(item.to)}
                  sx={{
                    fontSize: '12px',
                    fontWeight: 'medium',
                    color: '#666',
                    padding: '4px 8px',
                    minWidth: 'auto',
                    '&:hover': { 
                      backgroundColor: 'rgba(13, 147, 58, 0.1)',
                      color: colors.primary,
                    },
                    marginLeft: '8px',
                    transition: 'all 0.3s ease',
                  }}
                >
                  {item.label}
                </Button>
              ))}
            </Box>

            {/* Menus principaux */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              {primaryMenuItems.map((item) => (
                <Button
                  key={item.label || 'home'}
                  onClick={item.hasSubmenu ? 
                    (event) => handleMenuOpen(event, item.label) : 
                    () => handleNavigation(item.to)}
                  onMouseEnter={item.hasSubmenu ? (event) => handleMenuOpen(event, item.label) : undefined}
                  sx={{
                    fontSize: '14px',
                    fontWeight: item.label === 'ACCUEIL' ? 'normal' : 'bold',
                    color: colors.primary,
                    padding: '8px 12px',
                    minWidth: 'auto',
                    '&:hover': { 
                      backgroundColor: 'rgba(13, 147, 58, 0.1)',
                    },
                    marginLeft: '4px',
                    transition: 'all 0.3s ease',
                    borderBottom: currentMenu === item.label ? `2px solid ${colors.secondary}` : '2px solid transparent',
                  }}
                >
                  {item.icon}
                  <span style={{ marginLeft: item.icon ? '8px' : '0' }}>
                    {item.label}
                  </span> 
                </Button>
              ))}
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Desktop Dropdown Menus */}
      {primaryMenuItems.map((item) => (
        item.hasSubmenu && (
          <Menu
            key={item.label}
            anchorEl={anchorEl}
            open={Boolean(anchorEl) && currentMenu === item.label}
            onClose={handleMenuClose}
            MenuListProps={{ 
              onMouseLeave: handleMenuClose,
              sx: { py: 0 }
            }}
            sx={{
              '& .MuiPaper-root': {
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                border: `1px solid ${colors.primary}20`,
                minWidth: '280px'
              }
            }}
          >
            {getSubmenuItems(item.label).map((subItem) => (
              <MenuItem 
                key={subItem.label}
                onClick={() => handleNavigation(subItem.to)}
                sx={{
                  padding: '12px 16px',
                  borderBottom: '1px solid #f0f0f0',
                  '&:last-child': { borderBottom: 'none' },
                  '&:hover': { 
                    backgroundColor: 'rgba(13, 147, 58, 0.08)',
                  },
                  transition: 'all 0.2s ease'
                }}
              >
                <Typography 
                  sx={{ 
                    fontSize: '14px',
                    color: '#333',
                    fontWeight: '500'
                  }}
                >
                  {subItem.label}
                </Typography>
              </MenuItem>
            ))}
          </Menu>
        )
      ))}

      {/* Mobile Drawer */}
      <Drawer 
        anchor="left" 
        open={menuOpen} 
        onClose={handleDrawerToggle}
        sx={{
          '& .MuiDrawer-paper': {
            width: 320,
            backgroundColor: colors.background
          }
        }}
      >
        <Box sx={{ padding: '16px', textAlign: 'center', borderBottom: `2px solid ${colors.primary}` }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <img src={logoPath} alt="Logo INSBU" style={{ height: '50px' }} />
            <IconButton onClick={handleDrawerToggle}>
              <CloseIcon sx={{ color: colors.primary }} />
            </IconButton>
          </Box>
          <Typography variant="h6" sx={{ color: colors.primary, fontWeight: 'bold', mt: 1 }}>
            INSBU
          </Typography>
        </Box>
        
        <List sx={{ padding: 0 }}>
          {renderMobileMenuItems()}
        </List>

        {/* Secondary menu items in mobile */}
        <Box sx={{ padding: '16px', borderTop: `1px solid #eee` }}>
          <Typography variant="subtitle2" sx={{ color: colors.secondary, mb: 1, fontWeight: 'bold' }}>
            Liens rapides
          </Typography>
          {secondaryMenuItems.map((item) => (
            <Button
              key={item.label}
              onClick={() => handleNavigation(item.to)}
              sx={{
                justifyContent: 'flex-start',
                fontSize: '14px',
                color: '#666',
                padding: '8px 16px',
                width: '100%',
                '&:hover': { 
                  backgroundColor: 'rgba(227, 11, 20, 0.1)',
                },
              }}
            >
              {item.label}
            </Button>
          ))}
        </Box>
      </Drawer>
    </>
  );
};
export default NavigationBar;